<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('recurring_donation') }}
  div.text-sm.font-normal.basic600--text {{ $t('recurring_donation_desc') }}

  v-row.mt-8(no-gutters)
    v-col(cols="12" sm="7")
      div.d-flex
        div.pr-2
          div.text-md.font-medium.basic700--text {{ $t('offer_recurring_donation') }}
          div.text-md.font-normal.basic600--text {{ $t('offer_recurring_donation_desc') }}
        v-spacer
        div
          y-switch.mt-1.mb-n3.pa-0(v-model="recurringEnabled")

      v-divider.basic300.my-4

      div.text-md.font-medium.basic700--text {{ $t('default_payment_frequency') }}
      v-select.text-md.font-normal.round-xl.mt-2(v-model="defaultRecurring" outlined :items="recurringFrequencies" item-text="text" item-value="value" hide-details="auto")
        template(v-slot:append)
          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(color="info500" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SettingsRecurringPlan',
  data () {
    return {
      isLoading: false,
      recurringEnabled: false,
      defaultRecurring: 'one-time',
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
      recurringFrequencies: [
        { text: 'One-time', value: 'one-time' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Monthly', value: 'monthly' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    })
  },
  mounted () {
    if (this.campaign) {
      this.setData(this.campaign)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (campaign) {
      this.recurringEnabled = campaign.recurring_enabled
      this.defaultRecurring = campaign.default_recurring
    },
    saveData () {
      this.isLoading = true
      let data = {
        recurring_enabled: this.recurringEnabled,
        default_recurring: this.defaultRecurring,
      }
      this.$axios.patch(`/donations/${this.company.slug}/campaigns/${this.campaign.form.slug}`, data)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>